import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_ADMIN_USER = "ADMIN-USER:UPSERT_ADMIN_USER";

export interface UpsertAdminUserAction extends Action {
  type: typeof UPSERT_ADMIN_USER;
  organization: OrganizationKeyName;
  data: any;
  id?: string;
}

export const upsertAdminUserAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string
): UpsertAdminUserAction => ({
  type: UPSERT_ADMIN_USER,
  organization,
  data,
  id,
});
